/**
 * Auth correlation IDs for ForgeRock AM.
 *
 * - traceId / rootTransactionId: stable for the whole login SPA session (like IDM audit traceId)
 * - per-request transactionId: <root>-request-<n> (ForgeRock header; changes every AM call)
 */

import uuid from 'uuid/v4';

let rootTransactionId;

/**
 * Stable session correlation id (preferred for support / log search).
 * Alias of the root transaction id without -request-N suffix.
 * @returns {string}
 */
export function getAuthTraceId() {
  return getAuthRootTransactionId();
}

/**
 * @returns {string}
 */
export function getAuthRootTransactionId() {
  if (!rootTransactionId) {
    const urlParams = new URLSearchParams(window.location.search);
    rootTransactionId = urlParams.get('transactionId') || urlParams.get('traceId') || uuid();
  }
  return rootTransactionId;
}

/**
 * Per-request id for x-forgerock-transactionid (changes frequently by design).
 * @param {number} requestNumber
 * @returns {string}
 */
export function buildAuthRequestTransactionId(requestNumber) {
  return `${getAuthRootTransactionId()}-request-${requestNumber}`;
}
